import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Arial', sans-serif",
  },
  palette: {
    error: {
      main: "#af3241"
    }
  }
});

export default theme;